import styled from "@emotion/styled"
import { lightGrey, offWhite } from "../../globalCss"

export const Main = styled.main`
  width: 100%;
  margin: 0 auto;
  background-color: ${offWhite};
`
export const Background = styled.div`
  position: relative;
  top: 8rem;
`
